import { DEFAULT_SKU } from "@/components/Threekit/FlushHandlePlacement/constants"

import {
  COMPONENT_NAME,
  ITEMTYPE,
  NA,
  NO_SEAT,
  NOT_APPLICABLE,
  PDPTYPE,
  STOCK,
} from "@/components/Threekit/analytics/constants"

export const ACCORDION_ORDER = [
  "color",
  "flushingtech",
  "bowlheight",
  "handle",
  "seat",
  "installItems",
]

export const LAST_MOBILE_STEP_INDEX = 5

export const MAX_INNER_WIDTH = 1023

export const MOBILE_SLIDE_TO_SECTION = [
  "color",
  "flushingtech",
  "bowlheight",
  "handle",
  "seat",
  "installItems",
]

export const BATHROOM = "bathroom"

export const LEFT_HAND_TRIP_LEVER = "left-hand trip lever"

export const REGULAR_PRICE = "regular price"

export const TOILET_ACCESSORIES = "toilet accessories"

export const CORBELLE = "corbelle"

export const SERVICE_PARTS = "service parts"

export const REGULAR_FINISHED_GOODS = "regular finished goods"

export const TOILET_SEATS = "toilet seats"

export const COLOR_SELECTION_ID = "color selection"

export const CROSS_SELL = "cross-sell"

export const UPSELL = "upsell"

export const BASE_PRODUCT_INFO = {
  componentName: COMPONENT_NAME,
  bundleIds: NA,
  bundleProductColors: NA,
  defaultImageName: NA,
  frequency: NA,
  globalDiscount: 0,
  globalOffer: NA,
  globalPromotionPrice: 0,
  isRecommended: NA,
  isSendNow: NA,
  isSubscription: NA,
  itemType: ITEMTYPE,
  numberOfReviews: NA,
  priceState: REGULAR_PRICE,
  productBasePrice: 0,
  productType: NA,
  productCouponCode: NA,
  productCoupondiscount: 0,
  productFindingMethod: NA,
  productPartnerBuyNow: "false",
  productSalePrice: 0,
  productSuperSku: "false",
  quantity: 1,
  ratings: NA,
  waterSenseProduct: "false",
}

export const FLUSH_INFO_OVERRIDES = {
  category: BATHROOM,
  description: LEFT_HAND_TRIP_LEVER,
  pdpType: PDPTYPE,
  productCategory: TOILET_ACCESSORIES,
  productCollectionsName: CORBELLE,
  productColor: NA,
  productID: `K-${DEFAULT_SKU}`,
  productName: CORBELLE,
  productRoom: BATHROOM,
  productSaleable: "true",
  productStatus: STOCK,
  productTileName: CORBELLE,
}

export const INSTALL_ITEMS_INFO_OVERRIDES = {
  category: SERVICE_PARTS,
  description: NA,
  pdpType: REGULAR_FINISHED_GOODS,
  productCategory: SERVICE_PARTS,
  productCollectionsName: SERVICE_PARTS,
  productColor: NOT_APPLICABLE,
  productID: NA,
  productName: NA,
  productRoom: SERVICE_PARTS,
  productSaleable: "true",
  productStatus: NA,
  productTileName: SERVICE_PARTS,
  quantity: 0,
}

export const NO_SEAT_INFO_OVERRIDES = {
  category: BATHROOM,
  description: NO_SEAT.toLocaleLowerCase(),
  pdpType: REGULAR_FINISHED_GOODS,
  productBrand: NA,
  productCategory: TOILET_SEATS,
  productCollectionsName: NA,
  productColor: NA,
  productID: NA,
  productName: NA,
  productRoom: BATHROOM,
  productSaleable: "false",
  productStatus: NA,
  productTileName: NA,
  quantity: 0,
}
